import { en2JaBasePartsTranslates } from 'src/features/brands/atoms/us/constants/bases'
import { en2JaEmbroideryPartsTranslates } from 'src/features/brands/atoms/us/constants/embroidery'
import { ko2JaBasePartsTranslates } from 'src/features/brands/atoms/korea/constants/bases'
import { ko2JaColorPartsTranslates, ko2JaColorPartsTranslatesNoTanners } from 'src/features/brands/atoms/korea/constants/colors'
import { ko2JaEmbroideryPartsTranslates } from 'src/features/brands/atoms/korea/constants/embroidery'
import { Embroidery, State } from 'src/types'
import ja from 'src/locales/ja'
import { genEmbroideryCells } from 'src/features/generatePdf/helper/embroidery'
import { genBaseCells } from 'src/features/generatePdf/helper/glove'
import { genColorCellsByPosition } from 'src/features/generatePdf/helper'
import { colorCells2Condition } from 'src/features/generatePdf/helper/pdfDocuments/colorSettings'
import { en2JaColorPartsTranslates } from 'src/features/brands/atoms/us/constants/colors'

type HeadLabelObjects = {
  head: string
  label: string
}[]

export const korea2JapaneseTranslator = (targetObjects: HeadLabelObjects, key: 'base' | 'color' | 'embroidery'): HeadLabelObjects => {
  const ko2JaTranslators = {
    base: ko2JaBasePartsTranslates,
    color: ko2JaColorPartsTranslates,
    embroidery: ko2JaEmbroideryPartsTranslates
  }
  const excludes = {
    base: ['種別', 'ウェブ'],
    color: [],
    embroidery: ['刺繍内容']
  }
  return targetObjects.reduce((a, c) => {
    a.push({
      head: c.head,
      label: excludes[key].includes(c.head)
        ? c.label
        : ['レース', 'ヘリ革', 'ステッチ', 'ハミダシ', 'ムートン', 'ラベル'].includes(c.head)
          ? ko2JaColorPartsTranslatesNoTanners.find((p) => p.korea === c.label)?.japanese
          : ko2JaTranslators[key].find((p) => p.korea === c.label)?.japanese || ''
    })
    return a
  }, [])
}

export const en2JapaneseTranslator = (targetObjects: HeadLabelObjects, key: 'base' | 'color' | 'embroidery'): HeadLabelObjects => {
  const en2JaTranslators = {
    base: en2JaBasePartsTranslates,
    color: en2JaColorPartsTranslates,
    embroidery: en2JaEmbroideryPartsTranslates
  }
  const excludes = {
    base: ['種別', 'ウェブ'],
    color: [],
    embroidery: ['刺繍内容']
  }

  return targetObjects.reduce((a, c) => {
    a.push({
      head: c.head,
      label: excludes[key].includes(c.head) ? c.label : en2JaTranslators[key].find((p) => p.en === c.label)?.japanese || ''
    })
    return a
  }, [])
}

export const translatedBaseSettings = (state: State, isUsContents: boolean, isKoreaContents: boolean): HeadLabelObjects => {
  const baseSettingsBase = genBaseCells(state, state.baseModel.brand, state.baseModel.position, ja).map((x) => ({ head: x.head, label: x.label }))
  if (isUsContents) return en2JapaneseTranslator(baseSettingsBase, 'base')
  if (isKoreaContents) return korea2JapaneseTranslator(baseSettingsBase, 'base')
  return baseSettingsBase
}

export const translatedColorSettings = (state: State, isUsContents: boolean, isKoreaContents: boolean) => {
  const settings = genColorCellsByPosition(state.baseModel.position, state, state.baseModel.brand, ja)
  const settings1 = settings.filter((x) => !colorCells2Condition.includes(x.partsKey)).map((x) => ({ head: x.head, label: x.label }))
  const settings2 = settings.filter((x) => colorCells2Condition.includes(x.partsKey)).map((x) => ({ head: x.head, label: x.label }))

  if (isUsContents) {
    return { colorSettings1: en2JapaneseTranslator(settings1, 'color'), colorSettings2: en2JapaneseTranslator(settings2, 'color') }
  }
  if (isKoreaContents) {
    return { colorSettings1: korea2JapaneseTranslator(settings1, 'color'), colorSettings2: korea2JapaneseTranslator(settings2, 'color') }
  }
  return { colorSettings1: settings1, colorSettings2: settings2 }
}

export const translatedEmbroideries = (embroideries: Embroidery[], isUsContents: boolean, isKoreaContents: boolean): HeadLabelObjects[] => {
  const existEmbroideries = embroideries[0]?.content.trim().length > 0
  if (!existEmbroideries) return []
  return embroideries.map((e) => {
    const embroideryCells = genEmbroideryCells(e, ja)
    if (isUsContents) return en2JapaneseTranslator(embroideryCells, 'embroidery')
    if (isKoreaContents) return korea2JapaneseTranslator(embroideryCells, 'embroidery')
    return embroideryCells
  })
}
